import styled from "styled-components"

export const Section = styled.section`
    display: flex;
    padding: 140px 0 100px 0;
    height: calc(100vh - 240px);
`
